<template>
  <v-container
    class="edit-user mx-auto mt-10"
  >
    <div class="text-h3 text-center">
      {{isEditing ? 'Editar Usuario' : 'Registrar Usuario'}}
    </div>
    <v-form
      ref="form"
      class="d-flex flex-column"
      v-model="valid"
      @submit.prevent="saveUser"
    >

      <v-text-field
        v-model="user.avatarURL"
        :counter="255"
        label="URL de Avatar"
      ></v-text-field>

      <v-text-field
        v-model="user.firstName"
        :counter="255"
        :rules="requiredRule"
        label="Nombres"
        required
      ></v-text-field>

      <v-text-field
        v-model="user.lastName"
        :counter="255"
        :rules="requiredRule"
        label="Apellidos"
        required
      ></v-text-field>

      <v-text-field
        v-model="user.email"
        :rules="[...requiredRule, ...emailRules]"
        label="E-mail"
        required
      ></v-text-field>

      <v-select
        v-model="user.documentType"
        :items="documentTypes"
        item-text="name"
        item-value="id"
        label="Tipo de Documento"
        required
        dense 
      ></v-select>

      <v-text-field
        v-model="user.documentId"
        :counter="20"
        :rules="requiredRule"
        label="Número de Documento"
        required
        :disabled="user.documentType===undefined"
      ></v-text-field>

      <v-select
        v-model="user.physicalAddress.country"
        :items="countries"
        item-text="name"
        item-value="id"
        label="País"
        required
        dense 
      ></v-select>

      <v-select
        v-model="user.physicalAddress.province"
        :items="provinces"
        item-text="name"
        item-value="id"
        label="Provincia"
        required
        :disabled="!user.physicalAddress.country"
      ></v-select>

      <v-select
        v-model="user.physicalAddress.city"
        :items="cities"
        item-text="name"
        item-value="id"
        label="Ciudad"
        required
        :disabled="!user.physicalAddress.province"
      ></v-select>

      <v-text-field
        v-model="user.physicalAddress.address"
        :counter="50"
        :rules="requiredRule"
        label="Direccion"
        :disabled="!user.physicalAddress.city"
        required
      ></v-text-field>

      <v-text-field
        v-model="user.phoneNumber"
        :counter="50"
        :rules="requiredRule"
        label="Número de Teléfono"
        required
      ></v-text-field>

      <v-text-field
        v-for="(phoneNumber, index) in user.additionalPhoneNumbers"
        :key="index"
        v-model="user.additionalPhoneNumbers[index]"
        :counter="50"
        label="Número de Teléfono (adicional)"
        required
        append-icon="mdi-close"
        @click:append="removePhoneNumber(index)"
      ></v-text-field>
      <v-select
        v-model="user.currencyIso"
        :items="currencies"
        item-text="name"
        item-value="id"
        label="Moneda"
        required
        :key="currencyKey"
      ></v-select>

      <v-btn
        v-if="user.additionalPhoneNumbers && user.additionalPhoneNumbers.length < 2"
        @click="addPhoneNumber"
        class="align-self-start"
        type="button"
      >
        <v-icon>$plus</v-icon>
        Agregar número de teléfono
      </v-btn>

      <v-btn
        :disabled="!valid"
        color="info"
        type="submit"
        class="mt-5"
      >
        {{isEditing ? 'Editar' : 'Registrar'}}
      </v-btn>
    </v-form>
    
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'EditUser',
  data() {
    return {
      user: {
        additionalPhoneNumbers: [],
        physicalAddress:{},
        documentType: undefined,
        currencyIso: undefined
      },
      hasSaved: false,
      isEditing: false,
      valid: true,
      countries: [],
      provinces: [],
      cities: [],
      documentTypes: [],
      currencies:[],
      emailRules: [
        v => /.+@.+\..+/.test(v) || 'El formato del e-mail debe ser válido.',
      ],
      requiredRule: [
        v => !!v || 'Este campo es obligatorio.'
      ],
      currencyKey:0
    }
  },
  beforeMount() {
    this.provinces = ["Buenos Aires"]
    this.countries = ["Argentina"]
    this.cities = ["La Plata"]
    this.$cf_api.getCurrencies().then(resp=>{
      for(var i=0; i< resp.data.length; i ++){
        this.currencies.splice(0, 1,  { id: resp.data[i].currencyIso, name:resp.data[i].symbol+resp.data[i].currencyIso})
      }
      this.user.currencyIso = this.currencies[0].id 
    })
    this.$cf_auth.getDocumentTypes().then(response=>{
      for(var i = 0; i< response.data.length; i ++){
        this.documentTypes.splice(i,0,{ id:i, name:response.data[i]})
      }
    }).catch(e=>{
      console.log('Cf auth error:' + e)
    })
    if (this.$route.params.id) {
      this.isEditing = true;
      this.$cf_auth.getUser(this.$route.params.id).then(response=>{
        this.user = response.data
        this.user.documentType = parseInt(this.user.documentType)
        this.$cf_api.getFinancialAccountForUser(this.user.email).then(response=>{
          this.user.currencyIso = this.currencies.find(el=> el.id === response.data.accounts[0].currencyIso)
          this.currencyKey++
        })
      }).catch(e=>{
        console.log('Error getting user '+this.$route.params.id+' :',e)
      })
    }
  },
  methods: {
    loadData(name, callback) {
      axios.get(process.env.BASE_URL + `api/${name}.json`)
        .then(response => {
          callback(response.data);
        })
    },
    saveUser() {
      if(!this.isEditing){
        this.$cf_api.postUser(this.user).then(()=>{
          this.$store.dispatch('setSnack', 'Se ha creado usuario correctamente.')
          this.$router.push('/')
        }).catch(e=>{
          console.log('error creating user: '+e)
          this.$store.dispatch('setSnack', 'Hubo problemas creando usuario nuevo. Intente nuevamente más tarde.')
        })
      } else {
        this.user.currencyIso = this.user.currencyIso.id.toString()
        this.user.documentType = this.user.documentType.toString()
        this.$cf_auth.updateUser(this.user).then(()=>{
          this.$store.dispatch('setSnack', 'Se ha actualizado usuario correctamente.')
          this.$router.push('/')
        }).catch(e=>{
          console.log('error updating user: '+e)
          this.$store.dispatch('setSnack', 'Hubo problemas actualizando usuario. Intente nuevamente más tarde.')
        })
      }
    },
    addPhoneNumber() {
      this.user.additionalPhoneNumbers.push('');
    },
    removePhoneNumber(index) {
      this.user.additionalPhoneNumbers.splice(index, 1);
    }
  }
}

</script>

<style>
.edit-user {
  width: 60%;
}
</style>